<template>
  <div class="mobile-sidebar" :class="isOpen ? 'sidebar-open' : ''">
    <menu-icon v-if="!isOpen" @click="isOpen = true" />
    <p v-if="isOpen" class="close-icon">
      <close-icon @click="handleClose" />
    </p>
    <transition name="slide" mode="out-in">
      <sidebar-nav
        v-if="isOpen"
        class="sidebar-nav"
        v-on-clickaway="handleClose"
      />
    </transition>
  </div>
</template>

<script>
import SidebarNav from './sidebar-nav.vue'
import menuIcon from 'assets/images/icons/menu-icon.svg?inline'
import closeIcon from 'assets/images/icons/close-icon.svg?inline'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'mobile-sidebar',
  mixins: [clickaway],
  components: {
    menuIcon,
    closeIcon,
    SidebarNav,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    handleClose() {
      this.isOpen = false
    },
  },
}
</script>

<style scoped lang="scss">
.mobile-sidebar {
  width: 250px;
  position: fixed;
  padding-left: 25px;
  z-index: 1000;
  &.sidebar-open {
    height: 100%;
    padding-left: 0px;
  }
  svg {
    @extend %icon-std;
    cursor: pointer;
  }
}
.close-icon {
  text-align: right;
  margin-bottom: 0px;
  padding-right: 10px;
}
.sidebar-nav {
  height: 100%;
  background: #fff;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.1s linear;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-350px);
}
</style>
